<template>
  <vue-content-loading :width="300" :height="$vuetify.breakpoint.xsOnly ? 400 : 200">
    <rect
      :x="$vuetify.breakpoint.xsOnly ? 115 : 0"
      :y="$vuetify.breakpoint.xsOnly ? 30 : 0"
      :height="$vuetify.breakpoint.xsOnly ? 70 : 40"
      :width="$vuetify.breakpoint.xsOnly ? 70 : 40" />

    <rect
      :x="$vuetify.breakpoint.xsOnly ? 75 : 45"
      :y="$vuetify.breakpoint.xsOnly ? 115 : 15"
      :rx="5"
      :ry="5"
      :height="14"
      :width="150" />

    <rect
      :x="0"
      :y="$vuetify.breakpoint.xsOnly ? 150 : 40"
      :height="3"
      :width="300" />

    <rect
      :x="$vuetify.breakpoint.xsOnly ? 50 : 90"
      :y="$vuetify.breakpoint.xsOnly ? 175 : 50"
      :rx="5"
      :ry="5"
      :height="$vuetify.breakpoint.xsOnly ? 20 : 10"
      :width="$vuetify.breakpoint.xsOnly ? 200 : 120" />

    <rect
      :x="58"
      :y="$vuetify.breakpoint.xsOnly ? 200 : 65"
      :rx="2"
      :ry="2"
      :height="$vuetify.breakpoint.xsOnly ? 10 : 5"
      :width="185" />

    <rect
      :x="85"
      :y="$vuetify.breakpoint.xsOnly ? 215 : 72"
      :rx="2"
      :ry="2"
      :height="$vuetify.breakpoint.xsOnly ? 10 : 5"
      :width="130" />

    <rect
      :x="$vuetify.breakpoint.xsOnly ? 42 : 50"
      :y="$vuetify.breakpoint.xsOnly ? 250 : 90"
      :height="100"
      :width="$vuetify.breakpoint.xsOnly ? 218 : 200" />
  </vue-content-loading>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  components: {
    VueContentLoading,
  },
};
</script>
